export const formatDecimal = (value: number | string | null | undefined, decimals = 2, fallback = '-'): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) {
    return fallback;
  }

  return numberValue.toFixed(decimals);
};
